const schema = () => ({
  title: 'Chef',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['image', 'image_alt', 'eyebrow', 'heading', 'body', 'signature'],
    },
  ],
  properties: {
    image: {
      title: 'Portrait',
      type: 'string',
      widget: 'object_browser',
      mode: 'image',
    },
    image_alt: {
      title: 'Texte alternatif',
      type: 'string',
    },
    eyebrow: {
      title: 'Surtitre',
      type: 'string',
      default: 'Aux fourneaux',
    },
    heading: {
      title: 'Titre',
      type: 'string',
      default: 'Une cuisine de mémoire, *faite à la main.*',
      description:
        'Encadrez un fragment avec des astérisques pour le mettre en italique : *comme ceci*.',
    },
    body: {
      title: 'Texte',
      type: 'string',
      widget: 'textarea',
    },
    signature: {
      title: 'Signature',
      type: 'string',
      default: '— Le chef et son équipe, À Ciel Ouvert',
    },
  },
  required: [],
});

export default schema;
